// @ts-nocheck
import React from 'react'
import { get } from 'lodash'

import { AntdPopconfirm, FormFieldLayout, FormInput } from '../../generic'

const ConfirmFormInput = (props) => {
  const {
    className,
    confirmProps,
    error,
    inputType,
    onConfirm,
    placeholder,
    style,
    value,
    disabled,
    ...restProps
  } = props

  return (
    <div style={{ ...style, ...styles.wrapper }}>
      <div className={'lmc-field-confirm'}>
        <AntdPopconfirm confirmProps={confirmProps} onConfirm={onConfirm}>
          <FormInput
            className={className}
            error={error}
            inputStyle={confirmProps.confirmInputStyle}
            onChange={() => {}}
            placeholder={placeholder}
            value={value}
            type={inputType || 'text'}
            disabled={disabled}
            data-testid={restProps['data-testid']}
          />
        </AntdPopconfirm>
      </div>
    </div>
  )
}

export default function TextField({
  errors,
  formKey,
  inputStyle,
  inputType,
  onChange,
  className,
  placeholder,
  readOnly,
  maxlength,
  requireConfirm,
  style,
  values,
  disabled,
  ...props
}) {
  const [displayConfirm, setDisplayConfirm] = React.useState(requireConfirm)

  // checks for preferredName field, which conditionally renders text
  const value =
    formKey === 'preferredName' ? getDisplayName(values) : get(values, formKey)

  const error = get(errors, formKey)

  if (readOnly) return <ReadOnly value={value} />

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <div style={{ ...style, ...styles.wrapper }}>
        {displayConfirm ? (
          <ConfirmFormInput
            {...props}
            className={className}
            error={error}
            formKey={formKey}
            inputStyle={inputStyle}
            inputType={inputType}
            onChange={onChange}
            onConfirm={() => {
              setDisplayConfirm(false)
            }}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
          />
        ) : (
          <FormInput
            className={className}
            error={error}
            inputStyle={inputStyle}
            onChange={(e) => onChange({ key: formKey, value: e.target.value })}
            maxLength={maxlength}
            placeholder={placeholder}
            value={value}
            type={inputType || 'text'}
            disabled={disabled}
            data-testid={props['data-testid']}
          />
        )}
      </div>
    </FormFieldLayout>
  )
}

const ReadOnly = ({ value }) => <div style={styles.readOnly}>{value}</div>

const styles = {
  readOnly: {
    padding: '12px 12px 12px 0px',
  },
}

const getDisplayName = function (values) {
  const firstName = values.hasOwnProperty('name') ? values.name.first : ''
  return values.hasOwnProperty('preferredName')
    ? values?.preferredName
    : firstName
}
